import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

//components
import DollarsIcon from 'dibs-vg/dist/react/dollars';
import PdpSharedBlurb from './PdpSharedBlurb/PdpSharedBlurb';
import {
    tradeLoyaltyTitle,
    tpnTradeLoyaltyMessage,
    tradeLoyaltyEnrolledLink,
    tradeLoyaltyUnenrolledLink,
} from '../messages/pdpBlurbMessages';

//styles
import styles from './PdpSharedBlurbs.scss';

//helpers
import get from 'lodash.get';

const loyaltyLinks = {
    ENROLLMENT: '/trade/loyalty/enrollment/',
    REWARDS: '/trade/loyalty/rewards/',
};

export function PdpSharedBlurbTradeLoyalty({ user, viewer }) {
    const isEnrolled = get(user, 'tradeFirm.loyalty.isEnrolled');

    return (
        <PdpSharedBlurb Icon={DollarsIcon}>
            <span className={`${styles.title} ${styles.tradeLoyalty}`}>{tradeLoyaltyTitle}</span>
            <span>
                {tpnTradeLoyaltyMessage}{' '}
                <a
                    data-tn="trade-loyalty-link"
                    href={isEnrolled ? loyaltyLinks.REWARDS : loyaltyLinks.ENROLLMENT}
                    target="_blank"
                >
                    {isEnrolled ? tradeLoyaltyEnrolledLink : tradeLoyaltyUnenrolledLink}
                </a>
            </span>
        </PdpSharedBlurb>
    );
}

PdpSharedBlurbTradeLoyalty.propTypes = {
    user: PropTypes.object,
    viewer: PropTypes.object,
};

export default createFragmentContainer(PdpSharedBlurbTradeLoyalty, {
    user: graphql`
        fragment PdpSharedBlurbTradeLoyalty_user on User {
            tradeFirm {
                loyalty {
                    isEnrolled
                }
            }
        }
    `,
});
